// extracted by mini-css-extract-plugin
export default {"infoTaxForms":"TaxForms-module__infoTaxForms___zTT3q","items":"TaxForms-module__items___sDuoY ml-4 mt-2"};